import React from 'react';

const Contact = () => {
  return (
    <section className="bg-[#F9FAFB] py-12 md:py-16 px-4">
      <div className="max-w-7xl mx-auto bg-white border border-gray-100 rounded-2xl p-6 md:p-8 shadow-sm flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
        
        {/* Teks Informasi */}
        <div className="text-left">
          <h4 className="text-lg md:text-xl font-bold text-[#101828] mb-1">
            Masih belum menemukan jawaban pertanyaan Anda?
          </h4>
          <p className="text-sm md:text-base text-[#475467]">
            Hubungi kami melalui Email atau WhatsApp
          </p>
        </div>

        {/* Tombol Aksi */}
        <div className="flex flex-col sm:flex-row w-full md:w-auto gap-3">
          {/* Tombol WhatsApp */}
          <a 
            href='https://api.whatsapp.com/send?phone=6282113111610&text=Halo,%20saya%20ingin%20bertanya'
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center justify-center px-6 py-3 bg-[#F36F21] text-white rounded-xl text-sm font-bold hover:bg-[#E65C00] transition-all duration-200"
          >
            <img 
              src="https://summarecon-apps-dev-s3.s3.ap-southeast-3.amazonaws.com/stss/whatsapp.png" 
              alt="WhatsApp" 
              className="w-5 h-5 mr-2 object-contain"
            />
            Chat WhatsApp
          </a>

          {/* Tombol Email */}
          <a 
            href="mailto:csapps@summarecon.com"
            className="flex items-center justify-center px-6 py-3 bg-[#F36F21] text-white rounded-xl text-sm font-bold hover:bg-[#E65C00] transition-all duration-200"
          >
            <img 
              src="https://summarecon-apps-dev-s3.s3.ap-southeast-3.amazonaws.com/stss/mail-02.png" 
              alt="Email" 
              className="w-5 h-5 mr-2 object-contain"
            />
            Kirim Email
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;